import React from "react";

import { Text, View, TouchableOpacity, Image } from "react-native";

import Svg, { Path } from "react-native-svg";
import ImageComponent from "../../common/ImageComponent";

export default function SelectedTag(props) {
  const { tag, styles, showRemove, onRemoveTag = () => {} } = props;

  return (
    <View
      style={[
        styles.chip,
        styles.selectedChip,
        showRemove ? { paddingRight: 30 } : {},
      ]}
    >
      {tag.icon ? (
        <View style={styles.logoContainer}>
          <ImageComponent styles={styles.chipLogo} icon={tag.icon} />
        </View>
      ) : null}
      <Text style={[styles.chipText, styles.selectedChipText]}>{tag.name}</Text>
      {showRemove ? (
        <TouchableOpacity
          activeOpacity={0.5}
          onPress={() => onRemoveTag(tag)}
          style={[styles.removeButton]}
        >
          <Svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <Path
              opacity="0.502883"
              d="M11.1387 4.86139C11.0137 4.736 10.8438 4.66553 10.6667 4.66553C10.4896 4.66553 10.3198 4.736 10.1947 4.86139L8.00007 7.05739L5.8054 4.86139C5.54472 4.60071 5.12208 4.60071 4.8614 4.86139C4.60072 5.12206 4.60072 5.54471 4.8614 5.80539L7.0574 8.00005L4.8614 10.1947C4.60072 10.4554 4.60072 10.878 4.8614 11.1387C5.12208 11.3994 5.54472 11.3994 5.8054 11.1387L8.00007 8.94272L10.1947 11.1387C10.3634 11.3073 10.6091 11.3732 10.8395 11.3115C11.0699 11.2498 11.2498 11.0698 11.3115 10.8395C11.3732 10.6091 11.3074 10.3633 11.1387 10.1947L8.94274 8.00005L11.1387 5.80539C11.2641 5.68031 11.3346 5.51049 11.3346 5.33339C11.3346 5.15628 11.2641 4.98646 11.1387 4.86139Z"
              fill="white"
            />
            <Path
              opacity="0.502883"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 8C0 3.58172 3.58172 0 8 0C12.4165 0.00440984 15.9956 3.58355 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667C9.76811 14.6667 11.4638 13.9643 12.714 12.714C13.9643 11.4638 14.6667 9.76811 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8Z"
              fill="white"
            />
          </Svg>
        </TouchableOpacity>
      ) : null}
    </View>
  );
}
